import moment from "moment";

const timeToMinutes = (timeStr) => {
  const parts = timeStr.split(":");
  return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
};

export const isDateTimeAvailable = (
  date,
  disponibilidadeMedico,
  horarioAtendimentoFallback,
) => {
  const dayOfWeek = date.getDay();
  const timeInMinutes = date.getHours() * 60 + date.getMinutes();
  const dataCheck = moment(date).startOf("day");

  // Verificar exceções
  if (disponibilidadeMedico?.excecoes?.length > 0) {
    const excecaoNoDia = disponibilidadeMedico.excecoes.find((exc) =>
      moment(moment.utc(exc.data).format("YYYY-MM-DD")).isSame(
        dataCheck,
        "day",
      ),
    );

    if (excecaoNoDia) {
      if (excecaoNoDia.bloqueado) return false;
      if (excecaoNoDia.periodos?.length > 0) {
        return excecaoNoDia.periodos.some(
          (p) =>
            timeInMinutes >= timeToMinutes(p.start) &&
            timeInMinutes < timeToMinutes(p.end),
        );
      }
      return false;
    }
  }

  // Verificar períodos especiais
  if (disponibilidadeMedico?.periodosEspeciais?.length > 0) {
    const periodoAtivo = disponibilidadeMedico.periodosEspeciais.find((p) => {
      const inicio = moment(moment.utc(p.dataInicio).format("YYYY-MM-DD"));
      const fim = moment(moment.utc(p.dataFim).format("YYYY-MM-DD"));
      return dataCheck.isSameOrAfter(inicio) && dataCheck.isSameOrBefore(fim);
    });

    if (periodoAtivo) {
      const periodosHoje = periodoAtivo.horarioPadrao[dayOfWeek.toString()];
      if (!periodosHoje?.length) return false;
      return periodosHoje.some(
        (p) =>
          timeInMinutes >= timeToMinutes(p.start) &&
          timeInMinutes < timeToMinutes(p.end),
      );
    }
  }

  // Horário padrão
  if (disponibilidadeMedico?.horarioPadrao) {
    const periodosHoje =
      disponibilidadeMedico.horarioPadrao[dayOfWeek.toString()];
    if (!periodosHoje?.length) return false;
    return periodosHoje.some(
      (p) =>
        timeInMinutes >= timeToMinutes(p.start) &&
        timeInMinutes < timeToMinutes(p.end),
    );
  }

  // Fallback
  if (horarioAtendimentoFallback) {
    return (
      timeInMinutes >= timeToMinutes(horarioAtendimentoFallback.start) &&
      timeInMinutes < timeToMinutes(horarioAtendimentoFallback.end)
    );
  }

  return true;
};
